import { css } from '@emotion/css';

export const buttonStyles = css`
  padding-inline-start: 1.2rem;
  padding-inline-end: 0.8rem;
  max-width: 42rem !important;
  min-width: unset !important;
  height: 3.2rem !important;
  :hover {
    background: var(--interactive-white-hover) !important;
  }

  .arrow-icon {
    width: 1.6rem !important;
    height: 1.6rem !important;
  }

  .MuiButton-endIcon {
    margin-inline-start: 0.4rem;
  }

  svg {
    fill: var(--icon-secondary);
    :hover {
      fill: var(--icon-active) !important;
    }
  }

  &.selected {
    box-shadow: inset 0 0 0 2px var(--text-primary);
    svg {
      fill: var(--icon-primary);
    }
  }
`;
